// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"6d5ef65d","443":"2ad96b77","506":"a8fb72b1","513":"d841b8ba","699":"93c66fe5"}[chunkId] + ".chunk.js";
};